import React, { useRef, useEffect } from 'react';
import cn from 'classnames';
import Carousel, {
	ICarouselProps,
	CarouselItem,
} from 'tbk-components/src/components/Carousel';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface IDonationCallout {
	/**
	 * Donation Code
	 */
	donationCode?: string;
	/**
	 * Donation Callout Image  - Image should be 362px X 260px
	 */
	image?: IImage;
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Donation Link
	 */
	donationLink?: ILink;
}

export interface IDonationCalloutsProps extends IBaseElementProps {
	donationCallouts: IDonationCallout[];
}

/**
 * Donation Callouts
 * @block
 * @requiresHooks
 * @icon format-gallery
 */
const DonationCallouts: React.FC<IDonationCalloutsProps> = ({
	className,
	classNames = [],
	donationCallouts = [],
}) => {
	if (!Array.isArray(donationCallouts)) {
		return null;
	}

	return (
		<div
			className={
				className ||
				cn(
					'donation-callouts donation-callouts-container',
					...classNames,
				)
			}
		>
			<div className="container-fluid">
				<div className="donation-callouts__inner">
					<Carousel
						id="donation-callouts-carousel"
						className={className || cn('donation-callout-carousel')}
						showArrows
						showBullets={false}
						perView={3}
						options={{
							gap: 24,
							breakpoints: {
								960: {
									perView: 2,
								},
								768: {
									perView: 2,
								},
								576: {
									perView: 1,
								},
							},
						}}
					>
						{donationCallouts.map((donationCallout, index) => (
							<CarouselItem key={index}>
								<a
									className="donation-callout-item"
									href={donationCallout.donationLink && donationCallout.donationLink.href}
								>
									{donationCallout.donationCode && (
										<div className="donation-callout-item__code">
											<p>
												{donationCallout.donationCode}
											</p>
										</div>
									)}
									{donationCallout.image && (
										<div className="donation-callout__image-container">
											<Image
												{...donationCallout.image}
												className="donation-callout-item__image"
											/>
										</div>
									)}
									<div className="donation-callout-item__content">
										{donationCallout.heading && (
											<h3 className="donation-callout-item__heading">
												{donationCallout.heading}
											</h3>
										)}
										{donationCallout.donationLink && (
											<Button
												{...donationCallout.donationLink}
												className="btn btn-small btn-primary donation-callout-item__link"
											/>
										)}
									</div>
								</a>
							</CarouselItem>
						))}
					</Carousel>
				</div>
			</div>
		</div>
	);
};

export default DonationCallouts;
